export enum ELogLevel {
	ERROR = 'bg-brand-error-500',
	WARNING = 'bg-brand-warning-500',
	INFO = 'bg-brand-iceberg-400',
	SUCCESS = 'bg-brand-lilac-400',
}

